import { useTranslation } from 'react-i18next';
import { SectionHeader } from '../../UI';
import { useNoteReceivableForm } from '../hooks';
import { NoteReceivableCreateFileInput } from './NoteReceivableCreateFileInput';
import { NoteReceivableEstimatedValueInput } from './NoteReceivableEstimatedValueInput';
import { NoteReceivableFileList } from './NoteReceivableFileList';
import { NoteReceivableForm } from './NoteReceivableForm';
import { NoteReceivableNicknameInput } from './NoteReceivableNicknameInput';
import { NoteReceivableNotesInput } from './NoteReceivableNotesInput';
import { NoteReceivableOwnerDropdown } from './NoteReceivableOwnerInputDropdown';
import { NoteReceivableOwnershipAllocationInput } from './NoteReceivableOwnershipAllocationInput';

export interface StandardNoteReceivableFormVisibilityOptions {
  hideFileList?: boolean;
  hideCreateFileInput?: boolean;
}

interface StandardNoteReceivableFormProps {
  firmID: string;
  clientID: string;
  className?: string;
  visibilityOptions?: StandardNoteReceivableFormVisibilityOptions;
  children?: React.ReactNode;
  useNoteReceivableFormReturn: ReturnType<typeof useNoteReceivableForm>;
}

export function StandardNoteReceivableForm({
  children,
  clientID,
  firmID,
  className,
  visibilityOptions,
  useNoteReceivableFormReturn,
}: StandardNoteReceivableFormProps) {
  const { t: tForm } = useTranslation('form');
  const hideDocuments = visibilityOptions?.hideFileList && visibilityOptions?.hideCreateFileInput;

  return (
    <NoteReceivableForm className={className} useNoteReceivableFormReturn={useNoteReceivableFormReturn}>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <NoteReceivableNicknameInput className="col-span-2" autoFocus />
        <NoteReceivableEstimatedValueInput className="col-span-2" />
        <NoteReceivableNotesInput className="col-span-2" />
      </div>

      {!hideDocuments && (
        <>
          {!visibilityOptions?.hideFileList && <NoteReceivableFileList className="mt-4 md:mt-10" withTitle />}
          {!visibilityOptions?.hideCreateFileInput && <NoteReceivableCreateFileInput className="!ml-[-25px]" />}
        </>
      )}

      <SectionHeader header={tForm('general-ownership')} className="mt-4 md:mt-10" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <NoteReceivableOwnerDropdown dropdownMenuClassName="!w-[284px]" clientID={clientID} firmID={firmID} />
        <NoteReceivableOwnershipAllocationInput />
      </div>
      {children}
    </NoteReceivableForm>
  );
}
